import '../styles/Primitives.scss';

export default function Collapse({ children, className = '', in: expanded, timeout, unmountOnExit, ...props }) {
  if (!expanded && unmountOnExit) return null;
  return <div className={`ui-collapse ${className}`.trim()} hidden={!expanded} {...props}>{children}</div>;
}
